import { boxLayout3, boxLayout2, boxLayout1 } from './box.js';
import { extractTextBoxCssTokens } from './box.extractor.js';
import { colors } from './headings.js';

const tokens = {
  colors,
  boxes: {
    layout1: boxLayout1,
    layout2: boxLayout2,
    layout3: boxLayout3
  }
};
function extractTextCssTokens(config) {
  const [css, states] = extractTextBoxCssTokens(config);
  return [css, states];
}

export { extractTextCssTokens, tokens };
//# sourceMappingURL=index.js.map
